<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 -28 512 512">



        <g fill="black" class="TQ_animation_fadeIn">
            <path :class="{'lc_green' : index_n>=1}" d="m64.125 249.894531 34.992188 55.574219 33.296874-56.605469 63.667969-16.105469-43.546875-49.160156 4.359375-65.527344-60.210937 26.222657-60.976563-24.394531 6.335938 65.367187-42.042969 50.453125zm0 0"></path>
            <path :class="{'lc_purple' : index_n>=2}" d="m315.917969 232.757812 63.667969 16.105469 33.296874 56.605469 34.992188-55.574219 64.125-14.175781-42.042969-50.453125 6.335938-65.367187-60.976563 24.394531-60.210937-26.222657 4.359375 65.527344zm0 0"></path>
            <path :class="{'lc_gold' : index_n>=3}" d="m195.402344 186.507812 60.597656-25.3125 60.597656 25.3125-5.34375-65.457031 42.796875-49.8125-63.902343-15.140625-34.148438-56.097656-34.148438 56.097656-63.902343 15.140625 42.796875 49.8125zm0 0"></path>

            <path :class="{'lc_green' : index_n>=1}" d="m48.476562 351.253906h118.1875v104.929688h-118.1875zm0 0"></path>
            <path :class="{'lc_purple' : index_n>=2}" d="m345.335938 351.253906h118.1875v104.929688h-118.1875zm0 0"></path>
            <path :class="{'lc_gold' : index_n>=3}" d="m196.738281 351.253906h118.523438v104.929688h-118.523438zm0 0"></path>

            <path d="m191.835938 287.089844h128.328124v30.074218h-128.328124zm0 0"></path>
        </g>


    </svg>
</template>

<script>
    import {date_doEveryClockTick_addCb_f} from "../../scripts/S_Date";

    export default {
        name: "si_review",
        props:{
            p_id_s:{
                type: String,
                require:true,
            }
        },
        data(){
            return {
                index_n : 0
            }
        },
        created(){
            date_doEveryClockTick_addCb_f(this.$options.name + this.p_id_s,() => {
                this.index_n = (this.index_n + 1) % 5
            }, false )
        }
    }
</script>

<style scoped lang="scss">
    .lc_gold{
        fill:gold;
    }
    .lc_green{
        fill:green;
    }
    .lc_purple{
        fill:#501078;
        fill:var(--color-purple);
    }
    .lc_blue{
        fill:var(--color-blue);
    }




</style>